// Modules
import { FieldArray, Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { FileInput } from 'components/forms/form-elements';
import { RemoveButton } from 'components/widgets/buttons';
import { Row, Subform, SubformHeader } from 'components/forms/form-structure';
import { preventDefault } from 'utils/event-handlers';

class RenderMultipleFileUploadForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object,
    change: PropTypes.func,
    label: PropTypes.string.isRequired,
    meta: PropTypes.object
  };

  render() {
    const { fields, meta, change, label } = this.props;

    return (
      <Subform>
        <SubformHeader>
          {label}
          { meta.error && meta.error !== ' ' && <div className="invalid-alert">{meta.error}</div> }
        </SubformHeader>
        <div className="multiple-file-upload-inputs">
          { fields.map((name, index) => {
            const field = fields.get(index)[0];

            if (field.status === 'Archived') return null;

            return (
              <Row key={index}>
                <Field component={FileInput} disabled={!!field.id} name={name} />
                <RemoveButton
                  onClick={() => {
                    if (field.id) change(name, [_.defaults({ status: 'Archived' }, field)]);
                    else fields.remove(index);
                  }}
                  className="margin-left"
                />
              </Row>
            );
          }) }
          <a href="" onClick={preventDefault(() => fields.push([{}]))}>Add File</a>
        </div>
      </Subform>
    );
  }
}

// Component
export default function MultipleFileUploadForm(props) {
  return <FieldArray {...props} rerenderOnEveryChange component={RenderMultipleFileUploadForm} />;
}
